import {CopilotSuggestedUiPrompt} from './models/copilot.model.js'
export const TIME_ZONES = [
    {
      name: 'Alaska',
      title: '(GMT-09:00) Alaska'
    },
    {
      name: 'Pacific Time (US & Canada)',
      title: '(GMT-08:00) Pacific Time (US & Canada)'
    },
    {
      name: 'Arizona',
      title: '(GMT-07:00) Arizona'
    },
    {
      name: 'Mountain Time (US & Canada)',
      title: '(GMT-07:00) Mountain Time (US & Canada)'
    },
    {
      name: 'Central Time (US & Canada)',
      title: '(GMT-06:00) Central Time (US & Canada)'
    },
    {
      name: 'Eastern Time (US & Canada)',
      title: '(GMT-05:00) Eastern Time (US & Canada)'
    },
    {
      name: 'Indiana (East)',
      title: '(GMT-05:00) Indiana (East)'
    },
    {
      name: 'American Samoa',
      title: '(GMT-11:00) American Samoa'
    },
    {
      name: 'International Date Line West',
      title: '(GMT-11:00) International Date Line West'
    },
    {
      name: 'Midway Island',
      title: '(GMT-11:00) Midway Island'
    },
    {
      name: 'Tijuana',
      title: '(GMT-08:00) Tijuana'
    },
    {
      name: 'Chihuahua',
      title: '(GMT-07:00) Chihuahua'
    },
    {
      name: 'Mazatlan',
      title: '(GMT-07:00) Mazatlan'
    },
    {
      name: 'Central America',
      title: '(GMT-06:00) Central America'
    },
    {
      name: 'Guadalajara',
      title: '(GMT-06:00) Guadalajara'
    },
    {
      name: 'Mexico City',
      title: '(GMT-06:00) Mexico City'
    },
    {
      name: 'Monterrey',
      title: '(GMT-06:00) Monterrey'
    },
    {
      name: 'Saskatchewan',
      title: '(GMT-06:00) Saskatchewan'
    },
    {
      name: 'Bogota',
      title: '(GMT-05:00) Bogota'
    },
    {
      name: 'Lima',
      title: '(GMT-05:00) Lima'
    },
    {
      name: 'Quito',
      title: '(GMT-05:00) Quito'
    },
    {
      name: 'Atlantic Time (Canada)',
      title: '(GMT-04:00) Atlantic Time (Canada)'
    },
    {
      name: 'Caracas',
      title: '(GMT-04:00) Caracas'
    },
    {
      name: 'Georgetown',
      title: '(GMT-04:00) Georgetown'
    },
    {
      name: 'La Paz',
      title: '(GMT-04:00) La Paz'
    },
    {
      name: 'Santiago',
      title: '(GMT-04:00) Santiago'
    },
    {
      name: 'Newfoundland',
      title: '(GMT-03:30) Newfoundland'
    },
    {
      name: 'Brasilia',
      title: '(GMT-03:00) Brasilia'
    },
    {
      name: 'Buenos Aires',
      title: '(GMT-03:00) Buenos Aires'
    },
    {
      name: 'Greenland',
      title: '(GMT-03:00) Greenland'
    },
    {
      name: 'Montevideo',
      title: '(GMT-03:00) Montevideo'
    },
    {
      name: 'Mid-Atlantic',
      title: '(GMT-02:00) Mid-Atlantic'
    },
    {
      name: 'Azores',
      title: '(GMT-01:00) Azores'
    },
    {
      name: 'Cape Verde Is.',
      title: '(GMT-01:00) Cape Verde Is.'
    },
    {
      name: 'Edinburgh',
      title: '(GMT+00:00) Edinburgh'
    },
    {
      name: 'Lisbon',
      title: '(GMT+00:00) Lisbon'
    },
    {
      name: 'London',
      title: '(GMT+00:00) London'
    },
    {
      name: 'Monrovia',
      title: '(GMT+00:00) Monrovia'
    },
    {
      name: 'UTC',
      title: '(GMT+00:00) UTC'
    },
    {
      name: 'Amsterdam',
      title: '(GMT+01:00) Amsterdam'
    },
    {
      name: 'Belgrade',
      title: '(GMT+01:00) Belgrade'
    },
    {
      name: 'Berlin',
      title: '(GMT+01:00) Berlin'
    },
    {
      name: 'Bern',
      title: '(GMT+01:00) Bern'
    },
    {
      name: 'Bratislava',
      title: '(GMT+01:00) Bratislava'
    },
    {
      name: 'Brussels',
      title: '(GMT+01:00) Brussels'
    },
    {
      name: 'Budapest',
      title: '(GMT+01:00) Budapest'
    },
    {
      name: 'Casablanca',
      title: '(GMT+01:00) Casablanca'
    },
    {
      name: 'Copenhagen',
      title: '(GMT+01:00) Copenhagen'
    },
    {
      name: 'Dublin',
      title: '(GMT+01:00) Dublin'
    },
    {
      name: 'Ljubljana',
      title: '(GMT+01:00) Ljubljana'
    },
    {
      name: 'Madrid',
      title: '(GMT+01:00) Madrid'
    },
    {
      name: 'Paris',
      title: '(GMT+01:00) Paris'
    },
    {
      name: 'Prague',
      title: '(GMT+01:00) Prague'
    },
    {
      name: 'Rome',
      title: '(GMT+01:00) Rome'
    },
    {
      name: 'Sarajevo',
      title: '(GMT+01:00) Sarajevo'
    },
    {
      name: 'Skopje',
      title: '(GMT+01:00) Skopje'
    },
    {
      name: 'Stockholm',
      title: '(GMT+01:00) Stockholm'
    },
    {
      name: 'Vienna',
      title: '(GMT+01:00) Vienna'
    },
    {
      name: 'Warsaw',
      title: '(GMT+01:00) Warsaw'
    },
    {
      name: 'West Central Africa',
      title: '(GMT+01:00) West Central Africa'
    },
    {
      name: 'Zagreb',
      title: '(GMT+01:00) Zagreb'
    },
    {
      name: 'Athens',
      title: '(GMT+02:00) Athens'
    },
    {
      name: 'Bucharest',
      title: '(GMT+02:00) Bucharest'
    },
    {
      name: 'Cairo',
      title: '(GMT+02:00) Cairo'
    },
    {
      name: 'Harare',
      title: '(GMT+02:00) Harare'
    },
    {
      name: 'Helsinki',
      title: '(GMT+02:00) Helsinki'
    },
    {
      name: 'Jerusalem',
      title: '(GMT+02:00) Jerusalem'
    },
    {
      name: 'Kaliningrad',
      title: '(GMT+02:00) Kaliningrad'
    },
    {
      name: 'Kyiv',
      title: '(GMT+02:00) Kyiv'
    },
    {
      name: 'Pretoria',
      title: '(GMT+02:00) Pretoria'
    },
    {
      name: 'Riga',
      title: '(GMT+02:00) Riga'
    },
    {
      name: 'Sofia',
      title: '(GMT+02:00) Sofia'
    },
    {
      name: 'Tallinn',
      title: '(GMT+02:00) Tallinn'
    },
    {
      name: 'Vilnius',
      title: '(GMT+02:00) Vilnius'
    },
    {
      name: 'Baghdad',
      title: '(GMT+03:00) Baghdad'
    },
    {
      name: 'Istanbul',
      title: '(GMT+03:00) Istanbul'
    },
    {
      name: 'Kuwait',
      title: '(GMT+03:00) Kuwait'
    },
    {
      name: 'Minsk',
      title: '(GMT+03:00) Minsk'
    },
    {
      name: 'Moscow',
      title: '(GMT+03:00) Moscow'
    },
    {
      name: 'Nairobi',
      title: '(GMT+03:00) Nairobi'
    },
    {
      name: 'Riyadh',
      title: '(GMT+03:00) Riyadh'
    },
    {
      name: 'St. Petersburg',
      title: '(GMT+03:00) St. Petersburg'
    },
    {
      name: 'Tehran',
      title: '(GMT+03:30) Tehran'
    },
    {
      name: 'Abu Dhabi',
      title: '(GMT+04:00) Abu Dhabi'
    },
    {
      name: 'Baku',
      title: '(GMT+04:00) Baku'
    },
    {
      name: 'Muscat',
      title: '(GMT+04:00) Muscat'
    },
    {
      name: 'Samara',
      title: '(GMT+04:00) Samara'
    },
    {
      name: 'Tbilisi',
      title: '(GMT+04:00) Tbilisi'
    },
    {
      name: 'Volgograd',
      title: '(GMT+04:00) Volgograd'
    },
    {
      name: 'Yerevan',
      title: '(GMT+04:00) Yerevan'
    },
    {
      name: 'Kabul',
      title: '(GMT+04:30) Kabul'
    },
    {
      name: 'Ekaterinburg',
      title: '(GMT+05:00) Ekaterinburg'
    },
    {
      name: 'Islamabad',
      title: '(GMT+05:00) Islamabad'
    },
    {
      name: 'Karachi',
      title: '(GMT+05:00) Karachi'
    },
    {
      name: 'Tashkent',
      title: '(GMT+05:00) Tashkent'
    },
    {
      name: 'Chennai',
      title: '(GMT+05:30) Chennai'
    },
    {
      name: 'Kolkata',
      title: '(GMT+05:30) Kolkata'
    },
    {
      name: 'Mumbai',
      title: '(GMT+05:30) Mumbai'
    },
    {
      name: 'New Delhi',
      title: '(GMT+05:30) New Delhi'
    },
    {
      name: 'Sri Jayawardenepura',
      title: '(GMT+05:30) Sri Jayawardenepura'
    },
    {
      name: 'Kathmandu',
      title: '(GMT+05:45) Kathmandu'
    },
    {
      name: 'Almaty',
      title: '(GMT+06:00) Almaty'
    },
    {
      name: 'Astana',
      title: '(GMT+06:00) Astana'
    },
    {
      name: 'Dhaka',
      title: '(GMT+06:00) Dhaka'
    },
    {
      name: 'Urumqi',
      title: '(GMT+06:00) Urumqi'
    },
    {
      name: 'Rangoon',
      title: '(GMT+06:30) Rangoon'
    },
    {
      name: 'Bangkok',
      title: '(GMT+07:00) Bangkok'
    },
    {
      name: 'Hanoi',
      title: '(GMT+07:00) Hanoi'
    },
    {
      name: 'Jakarta',
      title: '(GMT+07:00) Jakarta'
    },
    {
      name: 'Krasnoyarsk',
      title: '(GMT+07:00) Krasnoyarsk'
    },
    {
      name: 'Novosibirsk',
      title: '(GMT+07:00) Novosibirsk'
    },
    {
      name: 'Beijing',
      title: '(GMT+08:00) Beijing'
    },
    {
      name: 'Chongqing',
      title: '(GMT+08:00) Chongqing'
    },
    {
      name: 'Hong Kong',
      title: '(GMT+08:00) Hong Kong'
    },
    {
      name: 'Irkutsk',
      title: '(GMT+08:00) Irkutsk'
    },
    {
      name: 'Kuala Lumpur',
      title: '(GMT+08:00) Kuala Lumpur'
    },
    {
      name: 'Perth',
      title: '(GMT+08:00) Perth'
    },
    {
      name: 'Singapore',
      title: '(GMT+08:00) Singapore'
    },
    {
      name: 'Taipei',
      title: '(GMT+08:00) Taipei'
    },
    {
      name: 'Ulaanbaatar',
      title: '(GMT+08:00) Ulaanbaatar'
    },
    {
      name: 'Osaka',
      title: '(GMT+09:00) Osaka'
    },
    {
      name: 'Sapporo',
      title: '(GMT+09:00) Sapporo'
    },
    {
      name: 'Seoul',
      title: '(GMT+09:00) Seoul'
    },
    {
      name: 'Tokyo',
      title: '(GMT+09:00) Tokyo'
    },
    {
      name: 'Yakutsk',
      title: '(GMT+09:00) Yakutsk'
    },
    {
      name: 'Adelaide',
      title: '(GMT+09:30) Adelaide'
    },
    {
      name: 'Darwin',
      title: '(GMT+09:30) Darwin'
    },
    {
      name: 'Brisbane',
      title: '(GMT+10:00) Brisbane'
    },
    {
      name: 'Canberra',
      title: '(GMT+10:00) Canberra'
    },
    {
      name: 'Guam',
      title: '(GMT+10:00) Guam'
    },
    {
      name: 'Hobart',
      title: '(GMT+10:00) Hobart'
    },
    {
      name: 'Melbourne',
      title: '(GMT+10:00) Melbourne'
    },
    {
      name: 'Port Moresby',
      title: '(GMT+10:00) Port Moresby'
    },
    {
      name: 'Sydney',
      title: '(GMT+10:00) Sydney'
    },
    {
      name: 'Vladivostok',
      title: '(GMT+10:00) Vladivostok'
    },
    {
      name: 'Magadan',
      title: '(GMT+11:00) Magadan'
    },
    {
      name: 'New Caledonia',
      title: '(GMT+11:00) New Caledonia'
    },
    {
      name: 'Solomon Is.',
      title: '(GMT+11:00) Solomon Is.'
    },
    {
      name: 'Srednekolymsk',
      title: '(GMT+11:00) Srednekolymsk'
    },
    {
      name: 'Auckland',
      title: '(GMT+12:00) Auckland'
    },
    {
      name: 'Fiji',
      title: '(GMT+12:00) Fiji'
    },
    {
      name: 'Kamchatka',
      title: '(GMT+12:00) Kamchatka'
    },
    {
      name: 'Marshall Is.',
      title: '(GMT+12:00) Marshall Is.'
    },
    {
      name: 'Wellington',
      title: '(GMT+12:00) Wellington'
    },
    {
      name: 'Chatham Is.',
      title: '(GMT+12:45) Chatham Is.'
    },
    {
      name: 'Nuku&#39;alofa',
      title: '(GMT+13:00) Nuku&#39;alofa'
    },
    {
      name: 'Samoa',
      title: '(GMT+13:00) Samoa'
    },
    {
      name: 'Tokelau Is.',
      title: '(GMT+13:00) Tokelau Is.'
    }
  ]

  export const DateRangeEnum={
    today:'today',
    yesterday:'yesterday',
    last7:'last7',
    last30:'last30',
    last90:'last90',
    customDate:'customDate',
  }

  export const DateRanges = [
    {
      label:"Today",
      value:DateRangeEnum.today
    },
    {
      label:"Yesterday",
      value:DateRangeEnum.yesterday
    },
    {
      label:"Last 7 days",
      value:DateRangeEnum.last7
    },
    {
      label:"Last 30 days",
      value:DateRangeEnum.last30
    },
    {
      label:"Last 90 days",
      value:DateRangeEnum.last90
    },
    {
      label:"Custom Date",
      value:DateRangeEnum.customDate
    },
  ]

  export const FileTypes = [//types to be adjusted
    { icon:'doc',
      label:'Document',
      type:'DOCUMENT'
    },
    { 
    icon:'pdf',
    label:'PDF',
    type:'PDF'
    },
    {
      icon:'xls',
      label:'Spreadsheet',
      type:'SPREADSHEET'
    },
   {
    icon:'png',
      label:'Photo or Image',
      type:"IMAGE"
    },
    {
      icon:'ppt',
      label:'Presentation',
      type:'PRESENTATION'
    },
   {
    icon:'mp3',
      label:'Audio',
      type:'AUDIO'
    },
   {
    icon:'mp4',
      label:'Video',
      type:'VIDEO'
    },
    {
      icon:'zip',
      label:'Archive',
      type:'ARCHIVE'
    },
    { 
      icon:'folder',
      label:'Folder',
      type:"FOLDER"
    },
    { 
      icon:'doc',
      label:'Other',
      type:"OTHER"
    },
   
  ]

  export const DOCUMENT_SUGGESTED_PROMPTS:CopilotSuggestedUiPrompt[] = [
    {
      title: 'Summarize Document',
      description: 'Get a quick and concise summary of the uploaded document.',
      icon: 'heroicons_solid:document-text',
      color: 'bg-blue-500',
      rag_code:'Summarizer'
    },
    {
      title: 'Extract Key Points',
      description: 'Identify and highlight important points from the document.',
      icon: 'heroicons_solid:light-bulb',
      color: 'bg-green-500',
      rag_code:'KPExtractor',
    },
    {
      title: 'Find References',
      description: 'Locate and view all citations or references in the document.',
      icon: 'heroicons_solid:book-open',
      color: 'bg-purple-500',
      rag_code:'RefFinder',
    },
    {
      title: 'Spanish Question Answering',
      description: 'Get questions and answers based on the uploaded document in spanish language',
      icon: 'heroicons_solid:question-mark-circle',
      color: 'bg-orange-500',
      rag_code:null
    },
  ];

  export const FOLDER_SUGGESTED_PROMPTS:CopilotSuggestedUiPrompt[]  = [
    {
      title: 'Summarize All Files',
      description: 'Generate a summary for all documents in the folder.',
      icon: 'heroicons_solid:folder',
      color: 'bg-yellow-500',
      rag_code:'KPExtractor',
    },
    {
      title: 'Extract Common Topics',
      description: 'Identify recurring themes across multiple files.',
      icon: 'heroicons_solid:book-open',
      color: 'bg-pink-500',
      rag_code:'KPExtractor',
    },
    {
      title: 'Cross-Document References',
      description: 'Find and link related references between documents.',
      icon: 'heroicons_solid:link',
      color: 'bg-indigo-500',
      rag_code:null,
    },
    {
      title: 'Spanish Question Answering',
      description: 'Get questions and answers based on the uploaded documents in folder.',
      icon: 'heroicons_solid:question-mark-circle',
      color: 'bg-orange-500',
      rag_code:null
    }
  ];

  export const ASSISTANT_ICON_MAP: Record<string, string> = {
    DefaultQA:        'heroicons_outline:question-mark-circle',
    SpanishQA:        'heroicons_outline:language',
    Summarizer:       'heroicons_outline:document-text',
    StructSummarizer: 'heroicons_outline:list-bullet',
    KPExtractor:      'heroicons_outline:sparkles',
    DataExtractor:    'heroicons_outline:table-cells',
    RefFinder:        'heroicons_outline:bookmark-square'
  };

export const CUSTOM_THEME_ELEMENTS_CLASSES = {
    "panther_default": {
    user_bubble:"user_bubble"
  }
}
